export default "/images/7c27201a2500137f00869296158b35c9.avif";